import React from 'react';
import parse from "html-react-parser";

import {Body, Header3} from "../styled/typography/Typography";
import {ContactRegionCardWrapper} from "../styled/cards/ContactRegionCardComponents";

const ContactRegionCard = ({region, email, tel, enter, leave, small}) => {
    return (
        <ContactRegionCardWrapper onMouseEnter={enter ? () => enter() : undefined}
                                  onMouseLeave={leave ? () => leave() : undefined}>
            <Header3 color="white" marginBottom="small" small={small}>
                {region}
            </Header3>
            {email &&
            <Body color="body-text" marginBottom="smaller">
                {email}
            </Body>
            }
            {tel &&
            <Body color="body-text" no small={small}>
                {parse(tel)}
            </Body>
            }
        </ContactRegionCardWrapper>
    );
};

export default ContactRegionCard;